import { render, staticRenderFns } from "./BannerClientStore.vue?vue&type=template&id=453d6b7e&scoped=true"
import script from "./BannerClientStore.vue?vue&type=script&lang=js"
export * from "./BannerClientStore.vue?vue&type=script&lang=js"
import style0 from "./BannerClientStore.vue?vue&type=style&index=0&id=453d6b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d6b7e",
  null
  
)

export default component.exports